"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const show = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-show` : '') + (description ? ` desc-show` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-show"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-show"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2124)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.6791 4.50159L12.353 4.50213C16.1328 4.58649 20.296 6.99081 23.3813 10.383C24.2081 11.3009 24.2081 12.695 23.3791 13.6154C20.286 17.0194 16.1414 19.4231 12.3466 19.4974H11.6767C7.85846 19.4231 3.71418 17.0189 0.621785 13.6129C-0.205014 12.695 -0.205014 11.3009 0.623928 10.3807C3.72001 6.97274 7.88737 4.57578 11.6791 4.50159ZM12.3341 6.00194H11.6787C8.36982 6.07977 4.56951 8.26839 1.73631 11.3869C1.42348 11.7343 1.42348 12.2617 1.73432 12.6068C4.56436 15.7239 8.34374 17.9191 11.6994 17.997H12.3237C15.6563 17.9191 19.4362 15.7242 22.2668 12.609C22.5796 12.2617 22.5796 11.7343 22.2692 11.3896C19.5263 8.37386 15.8639 6.21402 12.6443 6.01504L12.3341 6.00194ZM12 7.49899L12.2379 7.50523C13.345 7.56355 14.395 8.02915 15.1827 8.81715C16.0268 9.66143 16.5007 10.8066 16.5 12.0002C16.4994 14.4853 14.4844 16.4994 11.9992 16.499C9.51412 16.4986 7.49983 14.4837 7.50005 11.9986C7.50026 9.58447 9.40144 7.61449 11.7882 7.50389L12 7.49899ZM12.0002 8.99899C10.3433 8.99899 9.00019 10.342 9.00005 11.9987C8.9999 13.6555 10.3428 14.9987 11.9995 14.999C13.6563 14.9993 14.9996 13.6565 15 11.9996C15.0005 11.2038 14.6846 10.4405 14.1219 9.87766C13.5593 9.31487 12.796 8.99878 12.0002 8.99899Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2124"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = show;